











import { Component, Provide, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import {
  ProvidedPaneParam,
  PaneItem,
  TitlePaneTheme,
} from './types';

@Component
export default class SwTitlePaneGroup extends SwExtendedVue {
  @Prop({ type: String, default: 'dark' })
  groupTheme: TitlePaneTheme;

  @Provide()
  paneParam: ProvidedPaneParam = {
    dragPaneId: '',
    panesInfo: [],
  };

  @Provide()
  public claimPaneDrag(paneId: string, top: number, dragEl: HTMLElement) : void {
    let i;
    this.paneParam.dragPaneId = paneId;
    let tempPane: PaneItem = {
      paneId: '',
      ele: null,
      theme: 'light',
      height: 0,
      top: 0,
    };
    const parentEl = dragEl.parentNode as HTMLElement;
    let len;

    /*
     *1. remove the dragged pane from the panesInfo array
     *2. calculate the top value of each pane
     *3. calculate the insert position
     *4. insert the pane to the correct position
     *5. insert the dragged pane to the panesInfo array
    */

    i = 0;
    while (i < this.paneParam.panesInfo.length) {
      const item = this.paneParam.panesInfo[i];
      if (item.paneId === paneId) {
        this.paneParam.panesInfo.splice(i, 1);
        tempPane = Object.assign({}, item);
      } else {
        if (i === 0) {
          // the first item
          this.paneParam.panesInfo[i].top = 0;
        } else {
          this.paneParam.panesInfo[i].top = this.paneParam.panesInfo[i - 1].top +  this.paneParam.panesInfo[i - 1].height;
        }
        i += 1;
      }
    }

    // find out the inserted postion
    len = this.paneParam.panesInfo.length;
    if (top <= 0) {
      this.paneParam.panesInfo.unshift(tempPane);
      this.removeAndInsertEle(parentEl, dragEl, 0);

    } else if (top >= (this.paneParam.panesInfo[len - 1].top)) {
      this.paneParam.panesInfo.push(tempPane);
      this.removeAndInsertEle(parentEl, dragEl, len);

    } else {
      for (i = 1 ; i < this.paneParam.panesInfo.length ; i += 1) {
        if (top >= this.paneParam.panesInfo[i - 1].top && top < this.paneParam.panesInfo[i].top) {
          this.paneParam.panesInfo.splice(i, 0 , tempPane);
          this.removeAndInsertEle(parentEl, dragEl, i);
          break;
        }
      }
    }

    dragEl.style.position = 'relative';
    dragEl.style.width = '';
    dragEl.style.zIndex = '';
    dragEl.style.left = '';
    dragEl.style.top = '';

    i = 0;
    while (i < this.paneParam.panesInfo.length) {
      tempPane = this.paneParam.panesInfo[i - 1];
      this.paneParam.panesInfo[i].top = (i === 0) ? 0 : tempPane.top + tempPane.height;
      if (this.groupTheme === 'dark') {
        this.paneParam.panesInfo[i].theme = (i % 2 === 0) ? 'grey' : 'dark';
      } else {
        this.paneParam.panesInfo[i].theme = (i % 2 === 0) ? 'light' : 'light-grey';
      }
      i += 1;
    }

  }

  removeAndInsertEle(parentEl: HTMLElement, dragEl: HTMLElement, position: number) {
    parentEl.removeChild(dragEl);
    const refEl = (position === 0) ? parentEl.children[0] : parentEl.children[position - 1].nextSibling;
    parentEl.insertBefore(dragEl, refEl);
  }

  @Provide()
  public claimPaneInfo(paneId: string, ele: HTMLElement, height: number): void {
    const info:PaneItem = {
      paneId,
      ele,
      height,
      theme: 'light',
      top: 0,
    };
    let i = 0;
    let tempPane:PaneItem;
    for (i = 0; i < this.paneParam.panesInfo.length ; i += 1) {
      const item = this.paneParam.panesInfo[i];
      if (item.paneId === paneId) {
        tempPane = this.paneParam.panesInfo[i - 1];
        info.top = (i === 0) ? 0 : tempPane.top + tempPane.height;
        if (this.groupTheme === 'dark') {
          info.theme = (i % 2 === 0) ? 'grey' : 'dark';
        } else {
          info.theme = (i % 2 === 0) ? 'light' : 'light-grey';
        }
        this.paneParam.panesInfo[i] = info;
        break;
      }
    }
    if (i === this.paneParam.panesInfo.length) {
      tempPane = this.paneParam.panesInfo[i - 1];
      info.top = (i === 0) ? 0 : tempPane.top + tempPane.height;
      if (this.groupTheme === 'dark') {
        info.theme = (i % 2 === 0) ? 'grey' : 'dark';
      } else {
        info.theme = (i % 2 === 0) ? 'light' : 'light-grey';
      }

      this.paneParam.panesInfo.push(info);
    }
  }

  @Watch('groupTheme')
  onGroupThemeChange() {
    let i = 0;
    if (this.paneParam && this.paneParam.panesInfo) {
      for (i = 0; i < this.paneParam.panesInfo.length; i += 1) {
        if (this.groupTheme === 'dark') {
          this.paneParam.panesInfo[i].theme = (i % 2 === 0) ? 'grey' : 'dark';
        } else {
          this.paneParam.panesInfo[i].theme = (i % 2 === 0) ? 'light' : 'light-grey';
        }
      }
    }

  }

}
